// IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
// Объединение «назад» (AttrGrid: CustomMergeManager.mergeBack_extend / mergeBack_info, выключатель fe.ux.gridMergeBack): у строки с пустыми
// ключевыми колонками перед значением (отчёт «Баланс постачання та попиту», строка «Grand Pharm Trade LLC» под «Узбекистан»: Об'єкт, Тип
// показника, Країна пусты, значение — в колонке Суб'єкт) значение колонки k рисуется объединением [startCol..c2] от колонки дерева. Корень
// объединения у wijmo — левая ячейка, поэтому крест-подсветка шапки при наведении брала колонку startCol (Об'єкт), а не колонку значения.
// Чистая логика: какую колонку описывает ячейка под курсором, и строка подсказки по Alt «Колонка «X»: значение».

// mb — mergeBack_info строки ({ k, startCol } или null), col — колонка под курсором (hitTest), mr — объединённый диапазон ячейки
// ({ col, col2 } wijmo CellRange или null). plain — как вести себя вне объединения «назад»: 'merge' — колонка начала объединения (как было у
// крест-подсветки), 'col' — колонка под курсором (как было у слоёв обрезанной шапки и подсказки по удержанию).
export function mergeBackHoverCol(mb, col, mr, plain = 'merge') {
    if (typeof col !== 'number' || col < 0) return col
    const mrCol = (mr && typeof mr.col === 'number' && mr.col >= 0) ? mr.col : col
    // корень объединения «назад» (startCol) и пустые колонки перед значением → колонка значения k; диапазон с корнем в startCol покрывает и
    // пустые колонки ПОСЛЕ значения (mr.col2 > k) — они тоже описывают k. Ячейка значения в строке, которая сейчас в правке (без объединения), — k сама
    if (mergeBackIsShifted(mb, mrCol) && mrCol < mb.k) return mb.k
    return plain === 'col' ? col : mrCol
}

// ячейка — часть объединения «назад» (подсказка по Alt называет исходную колонку)
export function mergeBackIsShifted(mb, col) {
    return !!(mb && typeof col === 'number' && col >= mb.startCol && col <= mb.k && mb.k > mb.startCol)
}

const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

// строка подсказки «Колонка «Суб'єкт»: Grand Pharm Trade LLC» в разметке строк store.tooltip_html (tooltip-header / tooltip-text);
// tFn — t из '@/i18n' (подпись «Column «{column}»» переводится словарём uk / ru); '' — нет названия колонки или значения
export function mergeBackTipHtml(header, value, tFn) {
    const h = String(header ?? '').replace(/\s+/g, ' ').trim()
    const v = String(value ?? '').trim()
    if (!h || !v) return ''
    const label = typeof tFn === 'function' ? tFn('Column «{column}»', { column: h }) : `Column «${h}»`
    return `<b class='tooltip-header'>${esc(label)}:</b> <b class='tooltip-text'> ${esc(v)}</b>`
}
